import { create } from "zustand";

interface HookProps {
  open: boolean;
  allowanceId: string;
  setAllowanceId: (id: string) => void;
  onOpenChange: (open: boolean) => void;
}

export const useDeleteAllowanceModal = create<HookProps>()((set) => ({
  open: false,
  allowanceId: "",
  setAllowanceId: (id) =>
    set(() => ({
      allowanceId: id,
    })),
  onOpenChange: (open) =>
    set(() => ({
      open,
    })),
}));
